import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-[calc(100vh-12rem)] items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-7xl font-bold text-primary-600">404</h1>
        <h2 className="mt-4 text-2xl font-bold text-gray-900">Page Not Found</h2>
        <p className="mt-2 text-gray-500">
          Sorry, we could not find the page you are looking for.
        </p>
        <div className="mt-8 flex items-center justify-center space-x-4">
          <Link
            to="/"
            className="rounded-lg bg-primary-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 transition-colors"
          >
            Go Home
          </Link>
          <Link
            to="/exams"
            className="rounded-lg border border-gray-300 px-6 py-2.5 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 transition-colors"
          >
            Browse Exams
          </Link>
        </div>
      </div>
    </div>
  );
}
